import { render, staticRenderFns } from "./BaseCheckboxGroup.vue?vue&type=template&id=b88491a2&scoped=true&"
import script from "./BaseCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./BaseCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88491a2",
  null
  
)

export default component.exports